


















import { Component, Prop, Vue } from "vue-property-decorator";
import { ProgramPackTexts } from "../../bookings/programPackTexts";
import CzCard from "../cz/CzCard.vue";
import CzChip from "../cz/CzChip.vue";
import CzTitle from "../cz/CzTitle.vue";
import CzRing from "../cz/CzRing.vue";
import CzSegments from "../cz/CzSegments.vue";
import CzIcon from "../cz/CzIcon.vue";

const InProgress = 2;

// The header of a patient's program: status, name and how far it has gone. In My plan it is the way into the program.
@Component({ components: { CzCard, CzChip, CzTitle, CzRing, CzSegments, CzIcon } })
export default class ProgramPackHead extends Vue {
  @Prop({ type: Object, required: true }) enrollment!: any;
  @Prop({ type: Object, default: () => ({}) }) guidelines!: { [id: number]: any };
  @Prop({ type: [String, Object], default: "" }) to!: string | object;

  texts = ProgramPackTexts;

  get progress(): { value: number; max: number; label: string } {
    return ProgramPackTexts.progress(this.t, this.enrollment, this.guidelines);
  }

  get pendingText(): string {
    if (this.enrollment.status !== InProgress) return "";
    const pending = ProgramPackTexts.cards(this.enrollment, 0).reduce((n: number, k: any) => n + Math.max(0, Math.max(1, k.quantity) - k.bookings.length), 0);
    return pending ? ProgramPackTexts.count(this.t, pending, "1 appointment to book", "{0} appointments to book") : "";
  }

  t(key: string): string {
    return this.$t(key).toString();
  }
}
